import { Suspense, lazy } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// Lazy load pages for code splitting
const Index = lazy(() => import("./pages/Index"));
const Destinations = lazy(() => import("./pages/Destinations"));

const HowItWorks = lazy(() => import("./pages/HowItWorks"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const NotFound = lazy(() => import("./pages/NotFound"));

// Lazy load destination detail pages
const Istanbul = lazy(() => import("./pages/destinations/Istanbul"));
const Cappadocia = lazy(() => import("./pages/destinations/Cappadocia"));
const Aegean = lazy(() => import("./pages/destinations/Aegean"));
const BlackSea = lazy(() => import("./pages/destinations/BlackSea"));
const Gobeklitepe = lazy(() => import("./pages/destinations/Gobeklitepe"));
const VIP = lazy(() => import("./pages/VIP"));
const IstanbulStopover = lazy(() => import("./pages/IstanbulStopover"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={<div className="min-h-screen bg-background" />}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/destinations" element={<Destinations />} />
              <Route path="/destinations/istanbul" element={<Istanbul />} />
              <Route path="/destinations/cappadocia" element={<Cappadocia />} />
              <Route path="/destinations/aegean" element={<Aegean />} />
              <Route path="/destinations/black-sea" element={<BlackSea />} />
              <Route path="/destinations/gobeklitepe" element={<Gobeklitepe />} />
              <Route path="/vip" element={<VIP />} />
              <Route path="/istanbul-stopover" element={<IstanbulStopover />} />
              
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
